import { render, staticRenderFns } from "./ClientActivityContainer.vue?vue&type=template&id=739f28d0&"
import script from "./ClientActivityContainer.vue?vue&type=script&lang=js&"
export * from "./ClientActivityContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports